import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { useLang } from '../i18n';

/** Torna in cima: appare dopo ~600px di scroll, con lo scroll nativo. Non tocca la
 *  history: il tasto back del browser continua a ripristinare la posizione.
 *  Con «riduci animazioni» il salto è istantaneo.
 *  Da nascosto è anche fuori dal tab order (invisible + tabIndex -1): senza
 *  questo restava il primo stop di Tab, opacità 0, prima dello skip link. */
export const BackToTop = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goTop = () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <button
      type="button"
      aria-label={t('common.backToTop')}
      tabIndex={visible ? 0 : -1}
      onClick={goTop}
      className={`fixed bottom-6 right-6 z-50 grid h-12 w-12 place-items-center rounded-full bg-inchiostro text-carta transition-[transform,opacity,background-color] duration-300 hover:bg-inchiostro/85 ${
        visible ? 'translate-y-0 opacity-100' : 'invisible pointer-events-none translate-y-3 opacity-0'
      }`}
    >
      <ArrowUp size={18} strokeWidth={2} />
    </button>
  );
};
